import { Component, OnInit } from '@angular/core';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-koz-dokument-stavka-update-container',
  templateUrl: './koz-dokument-stavka-update-container.component.html',
  providers: [
    InlineContainerService
  ]
})
export class KozDokumentStavkaUpdateContainer<T extends BaseEntity> extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
    activatedRoute: ActivatedRoute,
    userService: UserService){
super(inlineContainerService, activatedRoute, userService);
}

}
